import store from '@/store'
export default {
  methods: {
    mute () {
      store.getters['global/callGetter'].localMuted ? this.$sip.answeredCallSession.unmute() : this.$sip.answeredCallSession.mute()
    }
  }
}
